import React from "react";
import { cn } from "../ui";

/**
 * A dialog body with a panel docked beside it — the resource picker or editor
 * next to the list it adds to. Side by side from 992px; below that the panel
 * takes the whole body while it is open, so a phone never squeezes two columns.
 *
 * Props: main (node), aside (node | null)
 */
const ResourceWorkspace = ({ main, aside }) => (
  <div className={cn("tw-grid tw-gap-6", aside && "min-[992px]:tw-grid-cols-[minmax(0,1fr)_minmax(0,1.15fr)]")}>
    <div className={cn("tw-min-w-0", aside && "max-[991px]:tw-hidden")}>{main}</div>
    {aside && (
      <div className="tw-min-w-0 tw-border-0 tw-border-solid tw-border-line min-[992px]:tw-border-l min-[992px]:tw-pl-6">
        {aside}
      </div>
    )}
  </div>
);

export default ResourceWorkspace;
